import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { Link } from 'dibs-elements/exports/Link';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';
import { trackEvent } from 'dibs-tracking';
import { FormattedMessage } from 'react-intl';
import { WORDPRESS_THUMB, WORDPRESS_MEDIUM, WORDPRESS_FULL } from '../../constants/imageConstants';

import styles from './SbSharedWordpressArticles.scss';

const getHeaderId = index => `wp-article-header-${index}`;
const getDescriptionId = index => `wp-article-description-${index}`;

function fireTracking({ source, title }) {
    trackEvent({
        category: 'ecommerce',
        action: 'promotion click',
        label: `editorial article: ${source} ${title}`,
    });
}

const SbSharedWordpressArticlesComponent = ({ itemSearch }) => {
    const articles = itemSearch?.wpArticles || [];
    if (!articles.length) {
        return null;
    }
    return (
        <HeadingLevel>
            {Heading => (
                <div className={styles.container}>
                    <Heading className={styles.sectionHeader}>
                        <FormattedMessage
                            defaultMessage="Read More"
                            id="abf.sb.SbSharedWordpressArticles.header"
                        />
                    </Heading>
                    <div className={styles.articlesWrapper}>
                        {articles.map((article, index) => (
                            <HeadingLevel key={`wp-article-container-${index}`}>
                                {() => (
                                    <Link
                                        ariaLabel={`Read more about ${article.title}`}
                                        ariaDescribedBy={`${getHeaderId(index)},${getDescriptionId(
                                            index
                                        )}`}
                                        buyerLinkType="standardLinkNoEffect"
                                        underline="none"
                                        href={article.link}
                                        target="_blank"
                                        dataTn={`wp-article-link-${index}`}
                                        className={styles.article}
                                        onClick={() => fireTracking(article)}
                                    >
                                        <div className={styles.articleElement}>
                                            <img
                                                className={styles.featuredImg}
                                                src={article.imageUrl.thumb}
                                                srcSet={`
                                                    ${article.imageUrl.thumb} ${WORDPRESS_THUMB}w,
                                                    ${article.imageUrl.medium} ${WORDPRESS_MEDIUM}w,
                                                    ${article.imageUrl.full} ${WORDPRESS_FULL}w
                                                `}
                                                sizes="(max-width: 320px) 100vw, 25vw"
                                                alt={article.title}
                                            />
                                        </div>
                                        <div className={styles.articleElement}>
                                            <Heading
                                                className={styles.header}
                                                id={getHeaderId(index)}
                                            >
                                                {article.title}
                                            </Heading>
                                            <p className={styles.body} id={getDescriptionId(index)}>
                                                {article.subtitle}
                                            </p>
                                        </div>
                                    </Link>
                                )}
                            </HeadingLevel>
                        ))}
                    </div>
                </div>
            )}
        </HeadingLevel>
    );
};

SbSharedWordpressArticlesComponent.propTypes = {
    itemSearch: PropTypes.object.isRequired,
};

export const SbSharedWordpressArticles = createFragmentContainer(
    SbSharedWordpressArticlesComponent,
    {
        itemSearch: graphql`
            fragment SbSharedWordpressArticles_itemSearch on ItemSearchQueryConnection {
                wpArticles(first: 2) {
                    title
                    imageUrl {
                        thumb
                        medium
                        full
                    }
                    subtitle
                    publishedDate
                    link
                    source
                }
            }
        `,
    }
);
